<div class="md-whiteframe-2dp" flex layout-padding>
  <h2 class="md-title">{{'PERSONAL' | translate}}</h2>
  <md-divider></md-divider>
  <md-list flex>
    <md-list-item ng-repeat="person in vm.people">
      <div layout="row">
        <p class="md-body-1">{{ person.email }}</p>
      </div>
      <md-divider ng-if="!$last"></md-divider>
    </md-list-item>
  </md-list>
</div>

<div class="md-whiteframe-2dp" flex layout-padding>
  <h2 class="md-title">{{'USERS_ACCESS' | translate}}</h2>
  <md-divider></md-divider>
  <md-list flex>
    <md-list-item ng-repeat="user in vm.users" ui-sref="home.userProfile({userId: user.id})">
      <div layout="row">
        <p class="md-body-1">{{ user.username }}</p>
      </div>
      <md-divider ng-if="!$last"></md-divider>
    </md-list-item>
  </md-list>
</div>